export const API_URL = process.env.REACT_APP_API_URL;
export const APP_ID = process.env.REACT_APP_APP_ID;
export const ANALYTICS_BASE_URL = process.env.REACT_APP_ADSTUDIO_ANALYTICS_BASE_URL;
export const ADID_MAPPER_BASE_URL = process.env.REACT_APP_ADSTUDIO_ADID_MAPPER_BASE_URL;
export const PROFILE_MANAGEMENT_BASE_URL = process.env.REACT_APP_ADSTUDIO_PROFILE_MANAGEMENT_BASE_URL;
export const CONTENT_ANALYTICS_BASE_URL = process.env.REACT_APP_ADSTUDIO_CONTENT_ANALYTICS_BASE_URL;

export const TYPE = {
    SUCCESS: 'success',
    ERROR: 'error'
}

export const ROLE = {
    ADMIN: 'ADMIN'
}

export const getSystemUser=()=>{
    if ((typeof localStorage !== 'undefined') && (localStorage.getItem("auth"))) {
        return JSON.parse(localStorage.getItem("auth"))
    }
}

export const urlParam=(data)=>{

    return new URLSearchParams(data)
}